// 跨 module 共用的 downstream script 的註冊目標。
//
// js/filters.js、js/services/**、js/directives/** 底下有 30 支檔案同時被
// desktop（InifECApp）、mobile（InifECMobileApp）與 SimpleApp 三者中的兩個以上載入。
// 舊 build 靠 concat 後的共用 function scope，這些檔案用裸 app 註冊 —— 註冊到哪個
// module 完全取決於「是哪一頁載入了它」。這種晚期繫結 bundler 無法表達，
// 因此改為統一註冊到本檔宣告的共享 module，再由三個 app 各自宣告依賴。
//
// 本檔刻意不宣告任何 top-level 變數：concat build 下全域只有一份 scope，
// 若在這裡寫 var app，會蓋掉 js/app.js 的 app。
//
// 載入順序：必須排在第一支跨 module 共用檔之前（見 build/manifest.js 與四支
// SimpleApp 頁面手寫的 <script> 清單）。
window.InifECShared = angular.module('InifECShared', []);
